import React from "react";

/**
 * CustomBtn component renders a custom button.
 * @param {string} buttonText - The text displayed on the button.
 * @param {string} type - The type of the button (e.g., "button", "submit").
 * @param {function} onClick - The function to call when the button is clicked.
 * @param {boolean} disabledbtn - Whether the button should be disabled.
 * @param {string} className - Additional CSS classes for styling the button.
 * @param {string} id - The ID of the button.
 * @returns {JSX.Element} Custom button component.
 */
function CustomBtn({
    buttonText,
    type,
    onClick,
    disabledbtn,
    className,
    id
}) {
    return (
        <button
            type={type}
            className={`submit_btn ${className}`}
            id={id}
            onClick={onClick}
            disabled={disabledbtn}
        >
            {buttonText}
        </button>
    )
}

export default CustomBtn;